import staticPageHeader from '@/components/static-page-header/static-page-header.vue';

export default {
  components: {
    staticPageHeader,
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-not-found/page-not-found.js